import Phaser from 'phaser';
import registerTiledJSONExternalLoader from 'phaser-tiled-json-external-loader';

import * as C from 'tower/constants';
import BattleScene from 'tower/scenes/battle';
import HUDScene from 'tower/scenes/hud';
import LevelIntroScene from 'tower/scenes/level-intro';
import PermadeathScene from './scenes/permadeath';
import LoadingScene from './scenes/loading';
import TitleScene from './scenes/title';
import GameIntroScene from './scenes/game-intro';
import CreditsScene from './scenes/credits';

declare global {
  interface Window {
    game: Phaser.Game;
  }
}

registerTiledJSONExternalLoader(Phaser);

window.addEventListener('load', () => {
  const game = (window.game = new Phaser.Game({
    type: Phaser.AUTO,
    width: C.GAME_WIDTH,
    height: C.GAME_HEIGHT,
    scale: {
      fullscreenTarget: document.body,
      mode: Phaser.Scale.FIT,
    },
    backgroundColor: '#000',
    pixelArt: true,
    render: {
      pixelArt: true,
    },
    input: {
      keyboard: true,
      gamepad: true,
    },
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: window.location.search.includes('debug'),
      },
    },
    scene: [
      new LoadingScene(),
      new TitleScene(),
      new GameIntroScene(),
      new LevelIntroScene(),
      new BattleScene(),
      new HUDScene(),
      new PermadeathScene(),
      new CreditsScene(),
    ],
  }));

  const fullScreenButton = document.querySelector<HTMLElement>('#fullscreen')!;
  fullScreenButton.addEventListener('click', () => {
    game.scale.toggleFullscreen();
  });
  game.scale.on('enterfullscreen', () => {
    fullScreenButton.classList.add('exit');
  });
  game.scale.on('leavefullscreen', () => {
    fullScreenButton.classList.remove('exit');
  });

  console.log('%cARE YOU TRYING TO CHEAT MY TOWER? GOOD.', 'font-weight: bold; font-size: 36px;');
  console.log(
    "There's not much in the console that can help, but there are source maps if you want to look at the code.",
  );
  console.log(
    '%cJust to be clear: None of the puzzles require you to use the browser devtools.',
    'font-weight: bold; font-size: 16px;',
  );
});
